// Service page content for Skills in Demand (Subclass 482).
// Sourced from docs/research/australian-visa-pathways.md §2.
// COMPLIANCE: we are not a registered migration agent and do not give migration
// advice or assess eligibility; the regulated advice and lodgement are a
// registered migration agent's. No guaranteed outcomes; we do not promise to
// find a sponsor; no unverified dollar figures or income thresholds stated as
// fact. "Who does what" disclosure and disclaimer are rendered by the shared
// page template.

const skillsInDemand482 = {
  groupSlug: "employer-sponsored",
  slug: "skills-in-demand-482",
  title: "Skills in Demand visa (Subclass 482)",
  eyebrow: "Employer Sponsored",
  intro:
    "The Subclass 482 lets an approved Australian employer sponsor a skilled worker to fill a nominated position. It replaced the old TSS and 457 visas in late 2024, with three streams and an improved pathway to permanent residence. It is a temporary visa, but for many people it is the first step toward staying long term.",

  chips: [
    { label: "Visa type", value: "Temporary, employer sponsored" },
    { label: "Sponsor", value: "Approved Australian employer" },
    { label: "Streams", value: "Specialist, Core Skills, Labour Agreement" },
    { label: "Leads to", value: "Permanent residence via the 186" },
  ],

  whoFor: [
    "Skilled workers with an Australian employer ready to sponsor them.",
    "Employers who need to fill a genuine position they cannot fill locally.",
    "People who want a real, improved pathway to permanent residence over time.",
  ],

  essentials: [
    {
      title: "An approved sponsoring employer",
      detail:
        "Your employer must hold or obtain Standard Business Sponsorship and lodge a nomination for your position.",
    },
    {
      title: "A nominated occupation",
      detail:
        "The position must match an eligible occupation on the applicable list (the Core Skills stream draws on the CSOL).",
    },
    {
      title: "The right stream for the salary",
      detail:
        "The Specialist Skills, Core Skills, and Labour Agreement streams each have their own salary and eligibility rules. Salary must meet the relevant threshold and the market rate for the role.",
    },
    {
      title: "Relevant skills and experience",
      detail:
        "You need the skills and qualifications for the occupation, plus the required period of recent relevant work experience.",
    },
    {
      title: "Labour market testing (usually)",
      detail:
        "The employer generally must show they tested the local labour market first, with some exemptions.",
    },
    {
      title: "Health, character, and English",
      detail:
        "Standard health, character, and English requirements apply to you and any family included.",
    },
  ],

  process: [
    {
      title: "Check the fit",
      detail:
        "A registered migration agent confirms the occupation, the right stream, and whether the role and salary meet the requirements before anyone commits. We organise the documents behind it.",
    },
    {
      title: "Guide the employer through sponsorship",
      detail:
        "We help the employer organise the paperwork to become an approved sponsor, and a registered migration agent advises on their obligations.",
    },
    {
      title: "Prepare the nomination",
      detail:
        "We prepare and organise the nomination for your position, including labour market testing evidence where it is required.",
    },
    {
      title: "Lodge the visa application",
      detail:
        "We build a thorough, well-documented file. A registered migration agent lodges the visa application and deals with the Department.",
    },
    {
      title: "Decision",
      detail:
        "The Department decides. If granted, you can work for your sponsor in the nominated role.",
    },
    {
      title: "Plan your PR pathway",
      detail:
        "A registered migration agent maps how your time on the 482 can count toward permanent residence through the 186, and we keep your records in order for it.",
    },
  ],

  faqs: [
    {
      q: "Can you find me an employer to sponsor me?",
      a: "No. We are a migration support and coordination service, not a recruitment agency, and we do not promise sponsorship or a job. Once a genuine role and willing employer exist, we prepare and organise the sponsorship, nomination, and visa documentation, and a registered migration agent assesses eligibility, advises you and the employer, and lodges.",
    },
    {
      q: "What are the three streams?",
      a: "The Specialist Skills stream is for high earners, the Core Skills stream is the main stream for occupations on the Core Skills Occupation List, and the Labour Agreement stream covers roles under a labour agreement. A registered migration agent works out which one fits your role and salary.",
    },
    {
      q: "Does the 482 lead to permanent residence?",
      a: "Yes, for many people. After working for your sponsor in the nominated occupation for the required period, you can generally access permanent residence through the 186 Temporary Residence Transition stream. A registered migration agent plans for this from the start, and we keep your records ready for it.",
    },
    {
      q: "What does it cost?",
      a: "There is a government Visa Application Charge, plus a nomination fee and the Skilling Australians Fund levy that the employer pays. These amounts are set by the government and change, so a registered migration agent confirms the current figures for your case rather than quoting an outdated number.",
    },
  ],

  related: ["employer-nomination-186", "regional-494", "skills-assessment"],

  lastVerified: "13 July 2026",
};

export default skillsInDemand482;
